import * as React from "react";
import { Chip } from "@mui/material";
import { Localized } from "@fluent/react";
import { ProjectProcessType } from "../../projectProcess/ProjectProcessApiClient";

type Mode = "text" | "chip";

type Props = {
    value?: string | null;
    mode?: Mode;
    size?: "small" | "medium";
    uppercase?: boolean;
    fallbackText?: React.ReactNode;
};

const MAP: Record<ProjectProcessType, { id: string; fallback: string }> = {
    VALIDATION: { id: "process-type-validation", fallback: "_Walidacja" },
    SUPPLIER_DOCUMENTATION: { id: "process-type-supplier-documentation", fallback: "_Dokumentacja" },
};

export const ProjectProcessTypeLabel: React.FC<Props> = ({
    value,
    mode = "text",
    size = "small",
    uppercase = true,
    fallbackText = "-",
}) => {
    const key = (uppercase ? (value ?? "").toString().trim().toUpperCase() : (value ?? "")) as ProjectProcessType;
    const entry = MAP[key];

    const labelNode = entry ? (
        <Localized id={entry.id}>
            <span>{entry.fallback}</span>
        </Localized>
    ) : (
        <>{fallbackText}</>
    );

    if (mode === "chip") {
        return <Chip size={size} label={labelNode} variant="outlined" />;
    }

    return (
        <>
            {labelNode}
        </>
    );
};
